export const initEmptyTranslatableValue = () => ({
    de: "",
    en: "",
    fr: "",
});

export const initDefaultGermanTranslatableValue = (value) => ({
    de: value,
    en: "",
    fr: "",
});

export const fillObjectsMissingLocalesWithEmptyTranslatableValues = (obj) => {
    return {
        de: "",
        en: "",
        fr: "",
        ...obj,
    }
}

export function initTranslatableValue(value) {
    console.log("initTranslatableValue", value);
    if (!value) {
        return initEmptyTranslatableValue();
    } else if (typeof value === "string") {
        return initDefaultGermanTranslatableValue(value);
    } else {
        return fillObjectsMissingLocalesWithEmptyTranslatableValues(value);
    }
}